module.exports = __webpack_public_path__ + "static/media/imgEmojiSkull@3x.62efd7a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/imgEmojiSkull@3x.png
// module id = 371
// module chunks = 22